import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["show", "onClick", "buttonText", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Collapse as ChakraCollapse } from '@chakra-ui/react';
import Button from '../Button';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var Collapse = ChakraCollapse;
export default function ExpandText(props) {
  var show = props.show,
    onClick = props.onClick,
    buttonText = props.buttonText,
    children = props.children,
    collapseProps = _objectWithoutProperties(props, _excluded);
  return _jsxs(_Fragment, {
    children: [_jsx(Collapse, _objectSpread(_objectSpread({
      in: show
    }, collapseProps), {}, {
      "data-testid": "wrapper",
      children: children
    })), _jsx(Box, {
      mt: "-5rem",
      height: "5rem",
      position: "relative",
      bg: "".concat(!show && 'linear-gradient(to bottom, var(--chakra-colors-fadedBaseWhite) 0%, var(--chakra-colors-baseWhite) 75%)')
    }), _jsx(Button, {
      size: "sm",
      variant: "tertiary",
      onClick: onClick,
      children: buttonText
    })]
  });
}